import { Doctor } from "./types/Doctor";

/**
 * The "Doctor" returned from doctor search differes slightly from a typical
 * physician resource object. Use this mapper to map to a physician resource
 * object.
 *
 * @param doctor A doctor object returned from search.
 */
export const mapDoctorToPhysicianResource = (doctor: Doctor) => {
  return {
    addressLine1: doctor.address,
    addressLine2: doctor.company,
    city: doctor.city,
    country: {
      description: "Norway",
      code: "OLI_NATION_NORWAY",
      listName: "",
    },
    name: doctor.name,
    phone: doctor.phone,
    zip: doctor.zipCode,
  };
};

/**
 * Use this if submitting doctor information to create or update primary
 * physician, manual flag needed to flag cases with manual physicians.
 *
 * @param doctor A doctor object returned from search.
 */
export const mapDoctorToPhysicianCommand = (
  doctor: Doctor,
  manual: boolean,
) => {
  return {
    addressLine1: doctor.address,
    addressLine2: doctor.company,
    city: doctor.city,
    country: {
      description: "Norway",
      code: "OLI_NATION_NORWAY",
      listName: "",
    },
    manual: manual,
    name: doctor.name,
    phone: doctor.phone,
    zip: doctor.zipCode,
  };
};
